/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//　外部リンクを別タブで開く
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// 商品詳細 タブ
const tabElements = document.querySelectorAll(".Product__SelectTab");
tabElements.forEach((tab, index, list) => {
  tab.addEventListener("click", (e) => {
    const featureTab = document.querySelector(".Product__SelectTab__Feature");
    const detailTab = document.querySelector(".Product__SelectTab__Detail");
    const reviewTab = document.querySelector(".Product__SelectTab__Review");
    const featureTabBottom = document.querySelector(".Product__SelectTab__Feature__bottom");
    const detailTabBottom = document.querySelector(".Product__SelectTab__Detail__bottom");
    const reviewTabBottom = document.querySelector(".Product__SelectTab__Review__bottom");
    
    const featureContents = document.querySelector(".Product__Feature");
    const detailContents = document.querySelector(".Product__Detail");
    const reviewContents = document.querySelector(".Product__Review");
    
    featureTab.classList.remove('is-active');
    detailTab.classList.remove('is-active');
    reviewTab.classList.remove('is-active');
    featureTabBottom.classList.remove('is-active');
    detailTabBottom.classList.remove('is-active');
    reviewTabBottom.classList.remove('is-active');
    
    if(e.target.classList.contains('Product__SelectTab__Feature') || e.target.classList.contains('Product__SelectTab__Feature__bottom')) {
      featureTab.classList.add('is-active');
      featureTabBottom.classList.add('is-active');
      featureContents.style.display = "block";
      detailContents.style.display = "none";
      reviewContents.style.display = "none";
    }
    if(e.target.classList.contains('Product__SelectTab__Detail') || e.target.classList.contains('Product__SelectTab__Detail__bottom')) {
      detailTab.classList.add('is-active');
      detailTabBottom.classList.add('is-active');
      featureContents.style.display = "none";
      detailContents.style.display = "block";
      reviewContents.style.display = "none";
    }
    if(e.target.classList.contains('Product__SelectTab__Review') || e.target.classList.contains('Product__SelectTab__Review__bottom') ) {
      reviewTab.classList.add('is-active');
      reviewTabBottom.classList.add('is-active');
      featureContents.style.display = "none";
      detailContents.style.display = "none";
      reviewContents.style.display = "block";
    }
  })
})

// 商品詳細アレンジレシピ スライダー
$(function(){
  $('.Product__Slider').slick({
    autoplay: true, // 自動でスクロール
    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
    speed: 5000, // スライドが流れる速度を設定
    cssEase: "linear", // スライドの流れ方を等速に設定
    slidesToShow: 4, // 表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, // 矢印非表示
    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
    variableWidth: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3, // 画面幅750px以下でスライド3枚表示
        }
      }
    ]
  });
});

// 商品詳細SP 「購入する」ボタン
$(function() {
  $(".Product__Float__Button").on("touchstart", e => {
    const speed = 600;
    const target = $(".Product__InfoWrapper");
    const position = target.offset().top - 100;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  })
})

// エバーエッグの特長 スライダー
$(function(){
  $('.feature-slider').slick({
    autoplay: true, // 自動でスクロール
    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
    speed: 5000, // スライドが流れる速度を設定
    cssEase: "linear", // スライドの流れ方を等速に設定
    slidesToShow: 4, // 表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, // 矢印非表示
    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
    variableWidth: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3, // 画面幅750px以下でスライド3枚表示
        }
      }
    ]
  });
});

// トップページ　フェードインアニメーション
$(function () {
    $(".js-text-fadein").each(function () {
      // 1文字ずつ<span>で囲む
      $(this)
        .children()
        .addBack()
        .contents()
        .each(function () {
          if (this.nodeType == 3) {
            $(this).replaceWith(
              $(this).text().replace(/(\S)/g, "<span>$1</span>")
            );
          }
        });
      // スクロールして要素が画面内に入ったら文字を表示
      $(this).on("inview", function () {
        // 1文字ずつ順番に表示(不透明にする)
        $(this).css({ opacity: 1 });
        for (let i = 0; i <= $(this).children("span").length; i++) {
          $(this)
            .children("span")
            .eq(i)
            .delay(75 * i) // 文字間の時間
            .animate({ opacity: 1, top: "0px" }); 
        }
      });
    });

    $(".js-fadein").each(function() {
      $(this).on("inview", function () {
        $(this).addClass("is-inview");
      });
    });
  });
